import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import GeneralDialog from '../../../shared/general-dialog';
import { useState } from 'react';
import { PolicyForm } from '../policy-dialog';

import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

interface PolicyOrganizationEditDialogProps {
  openOrganizationDialog: boolean;
  setOpenOrganizationDialog: (value: boolean) => void;
  clickedIndex: number;
  setValue: UseFormSetValue<PolicyForm>;
  disabled: boolean;
  getValues: UseFormGetValues<PolicyForm>;
  fieldName: `actionData.${number}.userModelTemplate.organizations`;
}

export default function PolicyOrganizationEditDialog({
  openOrganizationDialog,
  setOpenOrganizationDialog,
  clickedIndex,
  setValue,
  disabled,
  getValues,
  fieldName,
}: PolicyOrganizationEditDialogProps) {
  const [name, setName] = useState(() =>
    getValues(`${fieldName}.${clickedIndex}.name`)
  );
  const [title, setTitle] = useState(() =>
    getValues(`${fieldName}.${clickedIndex}.title`)
  );
  const [department, setDepartment] = useState(() =>
    getValues(`${fieldName}.${clickedIndex}.department`)
  );
  const [location, setLocation] = useState(() =>
    getValues(`${fieldName}.${clickedIndex}.location`)
  );
  const [symbol, setSymbol] = useState(() =>
    getValues(`${fieldName}.${clickedIndex}.symbol`)
  );
  const [costCenter, setCostCenter] = useState(() =>
    getValues(`${fieldName}.${clickedIndex}.costCenter`)
  );
  const [description, setDescription] = useState(() =>
    getValues(`${fieldName}.${clickedIndex}.description`)
  );

  const formValuesHaveChanged =
    name !== getValues(`${fieldName}.${clickedIndex}.name`) ||
    title !== getValues(`${fieldName}.${clickedIndex}.title`) ||
    department !== getValues(`${fieldName}.${clickedIndex}.department`) ||
    location !== getValues(`${fieldName}.${clickedIndex}.location`) ||
    symbol !== getValues(`${fieldName}.${clickedIndex}.symbol`) ||
    costCenter !== getValues(`${fieldName}.${clickedIndex}.costCenter`) ||
    description !== getValues(`${fieldName}.${clickedIndex}.description`);

  return (
    <GeneralDialog
      open={openOrganizationDialog}
      handleClose={() => {
        setOpenOrganizationDialog(false);
      }}
      title={'Edit Organization'}
      dialogContent={
        <Stack sx={{ px: 1 }} gap={4}>
          <Grid container spacing={4}>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                disabled={disabled}
                autoComplete="off"
                label="Organization Name"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
                disabled={disabled}
                autoComplete="off"
                label="Employee Title"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={department}
                onChange={(e) => {
                  setDepartment(e.target.value);
                }}
                label="Employee Department"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={location}
                onChange={(e) => {
                  setLocation(e.target.value);
                }}
                label="Location"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={symbol}
                onChange={(e) => {
                  setSymbol(e.target.value);
                }}
                label="Stock Symbol"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={costCenter}
                onChange={(e) => {
                  setCostCenter(e.target.value);
                }}
                label="Cost Center"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                label="Type of Employee"
                fullWidth
              />
            </Grid>
          </Grid>
        </Stack>
      }
      primaryButton={{
        loading: false,
        action: () => {
          if (formValuesHaveChanged) {
            setValue(`${fieldName}.${clickedIndex}.name`, name, {
              shouldDirty: true,
            });
            setValue(`${fieldName}.${clickedIndex}.title`, title, {
              shouldDirty: true,
            });
            setValue(`${fieldName}.${clickedIndex}.department`, department, {
              shouldDirty: true,
            });
            setValue(`${fieldName}.${clickedIndex}.location`, location, {
              shouldDirty: true,
            });
            setValue(`${fieldName}.${clickedIndex}.symbol`, symbol, {
              shouldDirty: true,
            });
            setValue(`${fieldName}.${clickedIndex}.costCenter`, costCenter, {
              shouldDirty: true,
            });
            setValue(`${fieldName}.${clickedIndex}.description`, description, {
              shouldDirty: true,
            });
          }

          setOpenOrganizationDialog(false);
        },
        disabled: !formValuesHaveChanged,
        title: 'Update',
      }}
    />
  );
}
